<div [ngClass]="{'tab-pane': true, active: isActive}">
    <app-post></app-post>
    <app-post [isClearfix]="false"></app-post>
    <app-post></app-post>
</div>
